import { createPermission } from '@backstage/plugin-permission-common';

/**
 * Frontend mirror of the backend Grafana entity-read permission.
 *
 * Keep the `name` value in sync with
 * `packages/backend/src/permissions/grafanaPermissions.ts`.
 *
 * Backstage matches permissions by `.name`, so an independent definition on
 * each side is the standard approach when there is no shared `-common`
 * package between the app and backend packages.
 */
export const grafanaEntityReadPermission = createPermission({
  name: 'grafana.entity.read',
  attributes: { action: 'read' },
});
